import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Form, Row, Col } from "react-bootstrap";
import SeasonStanding from "./SeasonStanding";
import { useAuth } from "../context/AuthContext";
import { useRequest } from "../hooks/useRequest";
import { getSeasonUrl } from "../config/api";
import { Season } from "../types/models";

function AdminSeasonScoresPage() {
  const { seasonId } = useParams();
  const auth = useAuth();
  const [gameType, setGameType] = useState<
    "regular" | "exhibition" | "playoff" | null
  >(null);

  const { data: season } = useRequest<Season>(
    seasonId ? getSeasonUrl(parseInt(seasonId)) : undefined,
    auth.token,
  );

  // Initialize game type from season when data is loaded
  useEffect(() => {
    if (season?.game_type && gameType === null) {
      setGameType(season.game_type);
    }
  }, [season, gameType]);

  if (!seasonId) {
    return <div>Season ID not found</div>;
  }

  const seasonName = season?.name || `Season ${seasonId}`;

  return (
    <div className="mt-4">
      <h3 className="mb-4">{seasonName} Scores & Stats</h3>

      {gameType && (
        <>
          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Game Type</Form.Label>
                <Form.Select
                  value={gameType}
                  onChange={(e) =>
                    setGameType(
                      e.target.value as "regular" | "exhibition" | "playoff",
                    )
                  }
                >
                  <option value="regular">Regular Season</option>
                  <option value="exhibition">Exhibition</option>
                  <option value="playoff">Playoffs</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <SeasonStanding
            seasonId={parseInt(seasonId)}
            title="Team Standings"
            gameType={gameType}
          />
        </>
      )}
    </div>
  );
}

export default AdminSeasonScoresPage;
